import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFieldOfStudy } from "../actions/fieldofStudyActions";

const FieldOfStudy = React.memo(() => {
  const dispatch = useDispatch();

  const fieldsList = useSelector((state) => state.fieldsList);
  const { fields, loading, error } = fieldsList;

  useEffect(() => {
    if (!fields) {
      dispatch(getFieldOfStudy());
    }
  }, [fields]);
  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {fields ? (
            fields.map((field, i) => (
              <>
                <option key={i + 3} value={field.Field_Of_Study}>
                  {field.Field_Of_Study}
                </option>
              </>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
});

export default FieldOfStudy;
